document.addEventListener('DOMContentLoaded', function () {
    initProgressSliders();
});

function initProgressSliders() {
    const sliders = document.querySelectorAll('.progress-slider-container');

    sliders.forEach(slider => {
        new ProgressSlider(slider);
    });
}

class ProgressSlider {
    constructor(container) {
        this.container = container;
        this.slidesWrapper = container.querySelector('.progress-slides-wrapper');
        this.slides = container.querySelectorAll('.progress-slide');
        this.prevButton = container.querySelector('.progress-nav-button.prev');
        this.nextButton = container.querySelector('.progress-nav-button.next');
        this.currentSlide = 0;
        this.totalSlides = this.slides.length;

        // 初始化
        if (this.totalSlides > 0) {
            this.init();
        }
    }

    init() {
        this.updateSlider();

        // 绑定按钮事件
        if (this.prevButton) {
            this.prevButton.addEventListener('click', () => this.prevSlide());
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', () => this.nextSlide());
        }

        // 触摸滑动支持
        this.enableTouchSwipe();
    }

    prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            this.updateSlider();
        }
    }

    nextSlide() {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide++;
            this.updateSlider();
        }
    }

    updateSlider() {
        this.slidesWrapper.style.transform = `translateX(-${this.currentSlide * 100}%)`;

        // 更新按钮状态
        if (this.prevButton) {
            this.prevButton.disabled = this.currentSlide === 0;
        }
        if (this.nextButton) {
            this.nextButton.disabled = this.currentSlide === this.totalSlides - 1;
        }
    }

    enableTouchSwipe() {
        let touchStartX = 0;
        let touchEndX = 0;
        const swipeThreshold = 50;

        this.slidesWrapper.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });

        this.slidesWrapper.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].clientX;
            const difference = touchStartX - touchEndX;

            if (Math.abs(difference) > swipeThreshold) {
                if (difference > 0) {
                    this.nextSlide();
                } else {
                    this.prevSlide();
                }
            }
        }, { passive: true });
    }
}